module.exports = __webpack_public_path__ + "static/img/gongsirongyu-bg.8037213c.png";